import { render, staticRenderFns } from "./per-order-xiang.vue?vue&type=template&id=e4f4f4bc&scoped=true&"
import script from "./per-order-xiang.vue?vue&type=script&lang=js&"
export * from "./per-order-xiang.vue?vue&type=script&lang=js&"
import style0 from "./per-order-xiang.vue?vue&type=style&index=0&id=e4f4f4bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f4f4bc",
  null
  
)

export default component.exports